import React from 'react';
import ReactDOM from 'react-dom/client';
import '@amzn/meridian-tokens/base/font/amazon-ember-monospace.css';
import '@fontsource-variable/inter';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
